import type { ReactNode } from "react";
import { useQuery } from "@tanstack/react-query";
import { notFound } from "@tanstack/react-router";
import { queryClient, trpc } from "~/utils/trpc";

export function useLiveAgentsAvailability() {
  return useQuery(
    trpc.liveAgents.getAvailability.queryOptions(undefined, {
      staleTime: 0,
      refetchInterval: 30_000,
    }),
  );
}

export async function requireLiveAgentsEnabled() {
  const availability = await queryClient.fetchQuery(
    trpc.liveAgents.getAvailability.queryOptions(undefined, { staleTime: 0 }),
  );
  if (!availability.enabled) throw notFound();
}

export function LiveAgentsGate({ children }: { children: ReactNode }) {
  const { data, isPending, isError } = useLiveAgentsAvailability();
  if (isPending) return null;
  if (isError || !data?.enabled) throw notFound();
  return children;
}
